























































import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import PageInitialMixin from '@/mixins/PageInitialMixin';

// 内容层级
import ContentLayer from '@/layers/ContentLayer.vue';

import ScanTitleGroup from './components/index/ScanTitle.vue';
import ActivitySlider from './components/index/ActivitySlider.vue';
import GroupTitleSection from './components/index/GroupTitleSection.vue';
import GroupActivityDeclare from './components/index/ActivityDeclare.vue';
import GroupHeadReward from './components/index/GroupHeadReward.vue';
import GroupDiscount from './components/index/GroupDiscount.vue';
import CourseGroup from './components/index/CourseGroup.vue';
import MyGroup from './components/index/MyGroup.vue';

import GroupActivitySection from '@/components/groupType/index/GroupActivitySection.vue';
import ScanTitle from '@/components/common/index/ScanTitle.vue';
import CourseDetail from '@/components/common/index/CourseDetail.vue';
import IndexContactInfo from '@/components/common/index/IndexContactInfo.vue';
import IndexInstitutionIntroList from '@/components/common/index/IndexInstitutionIntroList.vue';
import ActivityLink from '@/components/common/index/ActivityLink.vue';
import Referrer from '@/components/common/index/Referrer.vue';
import BarrageIndex from '@/components/common/index/BarrageIndex.vue';
import ActivityMainImageIndex from '@/components/common/index/ActivityMainImage.vue';
import IndexRuleIntro from '@/components/common/index/IndexRuleIntro.vue';

// 图标层级
import IconLayer from '@/layers/IconLayer.vue';
import BGMIcon from '@/components/common/index/BGMIcon.vue';
import ContactIcon from '@/components/common/index/ContactIcon.vue';
import PosterIcon from '@/components/common/index/PosterIcon.vue';
import RecruitIcon from '@/components/common/index/RecruitIcon.vue';
import InviteIcon from '@/components/common/index/InviteIcon.vue';
import MicroWebsiteIcon from '@/components/common/index/MicroWebsiteIcon.vue';
import ShareIcon from '@/components/common/index/ShareIcon.vue';
// 底部按钮层级
import FooterLayer from '@/layers/FooterLayer.vue';
import OneClickFooter from '@/components/common/index/OneClickFooter.vue';
import CheckFooter from '@/components/common/index/CheckFooter.vue';
import DemoFooter from '@/components/common/index/DemoFooter.vue';
import RouteAiFamily from '@/components/common/index/RouteAiFamily.vue';
import EditFooter from '@/components/common/edit/EditFooter.vue';
import GroupJoinFooter from './components/index/GroupJoinFooter.vue';
import fetch from '@/common/api/fetch';

// Mask层级
import MaskLayer from '@/layers/MaskLayer.vue';

import getActivityType from '@/common/utils/getActivityType';
import getUrlParam from '@/common/utils/getUrlParam';

@Component({
  components: {
    'content-layer': ContentLayer,
    'scan-title': ScanTitle,
    'scan-title-group': ScanTitleGroup,
    'activity-slider': ActivitySlider,
    'group-title-section': GroupTitleSection,
    'group-activity-declare': GroupActivityDeclare,
    'group-head-reward': GroupHeadReward,
    'group-discount': GroupDiscount,
    'group-course-desc': CourseDetail,
    'group-activity-section': GroupActivitySection,
    'course-group': CourseGroup,
    'index-contact-info': IndexContactInfo,
    'index-institution-intro-list': IndexInstitutionIntroList,
    'my-group': MyGroup,
    'activity-link': ActivityLink,
    'barrage-index': BarrageIndex,
    'activity-main-image-index': ActivityMainImageIndex,
    'index-rule-intro': IndexRuleIntro,
    referrer: Referrer,

    'icon-layer': IconLayer,
    'bgm-icon': BGMIcon,
    'contact-icon': ContactIcon,
    'poster-icon': PosterIcon,
    'recruit-icon': RecruitIcon,
    'invite-icon': InviteIcon,
    'microWebsite-icon': MicroWebsiteIcon,
    'share-icon': ShareIcon,

    'footer-layer': FooterLayer,
    'group-join-footer': GroupJoinFooter,
    'one-click-footer': OneClickFooter,
    'check-footer': CheckFooter,
    'demo-footer': DemoFooter,
    'edit-footer': EditFooter,
    'rouer-aifamly': RouteAiFamily,
    'mask-layer': MaskLayer
  }
})
export default class GroupIndex extends Mixins(PageInitialMixin) {
  @Getter('showBarrage') showBarrage!: boolean;
  @Getter('showData') showData!: boolean;
  @Getter('showWesiteBtn') showWesiteBtn!: boolean;
  @Getter('institutionTitle') institutionTitle!: string;
  @Getter('institutionSwitch') institutionSwitch!: string;
  @Getter('contactSwitch') contactSwitch!: boolean;
  @Getter('contactTitle') contactTitle!: boolean;
  @Getter('activitySwitch') activitySwitch!: boolean;
  @Getter('activityTitle') activityTitle!: boolean;
  @Getter('unGroupSwitch') unGroupSwitch!: boolean;
  @Getter('showExtId') showExtId!: string;
  @Getter('section') section!: any;
  @Getter('cancel') cancel!: boolean;
  @Getter('hasPay') hasPay!: number;
  @Getter('deadline') deadline!: number;
  @Getter('startTime') startTime!: number;
  @Getter('nickname') nickname!: string;
  @Getter('avatar') avatar!: string;
  @Getter('uid') uid!: string;

  getUrlParam: Function = getUrlParam;
  getActivityType: Function = getActivityType;
  showScanTitle: boolean = false;

  mounted() {
    setTimeout(() => {
      this.showScanTitle = this.showData == undefined ? true : this.showData;
    }, 2000);
  }
  
  
}
